import React, { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import Account from "../Components/Account";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaPlusCircle, FaMoneyCheck } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

function Accounts() {
  const { state, changeAccount } = useContext(AuthContext);
  const [accounts, setAccounts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/accounts/`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setAccounts(response.data.accounts);
      setIsLoading(false);
    }
    fetch();
  }, []);

  const resetUserCodes = async (accountId) => {
    setIsLoading(true);
    await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/accounts/reset/users/${accountId}`,
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setIsLoading(false);
    toast("Códigos reseteados");
  };

  const checkAccountDiscrepancies = async () => {
    setIsLoading(true);
    await axios({
      method: "post",
      url: `${process.env.REACT_APP_BACKEND_URL}/accounts/check-payments`,
      data: {
        startDate: startDate,
        endDate: endDate,
        userTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      },
      headers: {
        Authorization: `Bearer ${state.token}`,
      },
    });
    setIsLoading(false);
    setShow(false);
    toast("Discrepancias verificadas");
  };

  if (isLoading) {
    return <Spinner animation="border" />;
  } else {
    return (
      <Col className="accounts">
        <Col className="accounts-header">
          <Row className="align-items-center">
            <Col lg={9}>
              <ToastContainer />
              <h4>Fraccionamientos</h4>
            </Col>
            <Col lg={3} className="right icon">
              <FaPlusCircle
                onClick={() => navigate("/new-account")}
                className="mx-2"
              />
              <FaMoneyCheck onClick={handleShow} />
            </Col>
          </Row>
        </Col>
        <Col className="accounts-content">
          {accounts.map((item) => (
            <Account
              name={item.name}
              id={item._id}
              key={item._id}
              changeAccount={changeAccount}
              role={state.role}
              resetUserCodes={resetUserCodes}
            />
          ))}
        </Col>
        <Modal show={show} onHide={handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              <h2>Revisar discrepancias?</h2>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Fecha de inicio</Form.Label>
                <DatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
                <Form.Label>Fecha de fin</Form.Label>
                <DatePicker
                  selected={endDate}
                  onChange={(date) => setEndDate(date)}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Cerrar
            </Button>
            <Button
              variant="primary"
              onClick={() => checkAccountDiscrepancies()}
            >
              Revisar
            </Button>
          </Modal.Footer>
        </Modal>
      </Col>
    );
  }
}

export default Accounts;
